import { React, models, kea, history, resources, selectores, componentToRx, Route, withRouter } from "app/main/std";
import { observeResource } from "kea-resource";
import {  columnas } from "./columns";

const resource = resources.UsuarioApi;
const observable = observeResource(resource.query, {});

type Entity = models.UsuarioApi;
export class UsuarioApiList extends React.PureComponent {
    modalManager = kea.createModalManager();

    onBorrar = async (x: Entity) => {
        if(await kea.yesno("¿Borrar usuario API?", x.Nombre)){
            await resource.delete(x.IdRegistro);
        }
    }

    onEdit = (x: Entity) => history.go("/catalogos/UsuarioApi/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/UsuarioApi/new");
    onRegresar = () => history.go("/catalogos");


    render() {
        const cols = columnas(this);

        return (
            <div>
                <kea.Title titulo="Usuarios API" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"UsuariosApiListCookieKey"} items={observable} />
                {this.modalManager.component}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/list/index.tsx